<h2>Signup</h2>
<p class="banner">
  Please enter county/district to continue the signup process.
</p>
<form>
  <div class="form-row px-2">
    <span id="countyLabel">County: </span>
    <select class="form-control" name="county" [(ngModel)]="selectedCounty" (change)="countySelected()" aria-label="County" aria-describedby="countyLabel">
      @for (f of counties; track f) {
        <option value="{{f.id}}">
          {{ f.name }}
        </option>
      }
    </select>
  </div>
  @if (selectedCounty != null) {
    <div class="form-row px-2">
      <span id="districtLabel">District: </span>
      <select class="form-control" name="district" [(ngModel)]="selectedDistrict" #q (change)="districtSelected()" aria-label="District" aria-describedby="districtLabel">
        @for (d of districts; track d) {
          <option value="{{d.districtID}}">
            {{ d.name }}
          </option>
        }
      </select>
    </div>
  }
  @if (districtUsers.length > 0) {
    <div>
      <p class="mt-4">The organization you are signing up for has already created an account. Please contact one of the users below:</p>
      <table class="table mt-3">
        <thead>
          <th>Name</th>
          <th>Email</th>
        </thead>
        <tbody>
          @for (row of districtUsers; track row) {
            <tr>
              <td>{{row.name}}</td>
              <td>{{row.email}}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
  @if (showSignupForm) {
    <div class="mt-3">
      <h4>Contact Information</h4>
      <div class="form-row">
        <div class="col-md-4">
          <label for="fname">First Name</label>
          <input id="fname" type="text" [(ngModel)]="inputForm.fname" class="form-control" name="fname" placeholder="First Name" />
        </div>
        <div class="col-md-4">
          <label for="lname">Last Name</label>
          <input id="lname" type="text" [(ngModel)]="inputForm.lname" class="form-control" name="lname" placeholder="Last Name" />
        </div>
        <div class="col-md-4">
          <label for="title">Title</label>
          <input id="title" type="text" [(ngModel)]="inputForm.title" class="form-control" name="title" placeholder="Title" />
        </div>
      </div>
      <div class="form-row">
        <div class="col-md-4">
          <label for="username">Username</label>
          <input id="username" type="text" [(ngModel)]="inputForm.username" class="form-control" name="username" placeholder="Username" />
        </div>
        <div class="col-md-4">
          <label for="email">Email</label>
          <input id="email" type="text" [(ngModel)]="inputForm.email" class="form-control" name="email" placeholder="Email" />
        </div>
        <div class="col-md-4">
          <label for="phone">Phone</label>
          <input id="phone" type="text" [(ngModel)]="inputForm.phone" class="form-control" name="phone" placeholder="Phone" />
        </div>
      </div>
      <app-button-group [buttonCount]=1>
        <button role="button" aria-label="Submit" (click)="submit()" name="submitSignup" class="btn btn-primary">Submit</button>
      </app-button-group>
    </div>
  }
</form>

